import { useMutation, useQueryClient } from "@tanstack/react-query";
import { message } from "antd";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { AppStrings } from "../../utils/constants/AppStrings";
import { getApiErrorMessage } from "../../utils/ErrorUtils";
import { bonusAdminEnvelope } from "./bonusAdminBody";
import { LIST_TEMPLATES_QUERY_KEY } from "./useListTemplates";
import { getTemplateQueryKey } from "./useGetTemplate";

type StoredToken = { AccessToken?: string };

async function deleteTemplate(templateId: string): Promise<string | undefined> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.DELETE_DYNAMIC_BONUS_TEMPLATE.replace("{template_id}", templateId);
  const response = await instance.delete(url);
  return bonusAdminEnvelope(response).message;
}

export const useDeleteTemplate = (templateId: string) => {
  const queryClient = useQueryClient();

  return useMutation<string | undefined, Error, void>({
    mutationFn: () => deleteTemplate(templateId),
    onSuccess: (beMessage) => {
      queryClient.invalidateQueries({ queryKey: LIST_TEMPLATES_QUERY_KEY });
      queryClient.removeQueries({ queryKey: getTemplateQueryKey(templateId) });
      message.success(beMessage || AppStrings.PAM_GENERIC_REQUEST_SUCCEEDED);
    },
    onError: (error) => {
      message.error(getApiErrorMessage(error, AppStrings.PAM_GENERIC_REQUEST_FAILED));
    },
  });
};
